import { getData } from 'api/requests/GET_ASSETS';

import { getQueryKey } from 'helpers/getQueryKey';
import { hash } from 'helpers/hash';

type Params = { id: string; type: string };

export const getAssetOptions = (params: Params) => {
  return {
    queryKey: getQueryKey('ASSETS', hash(params)),
    queryFn: () => {
      return getData(params.id, params.type);
    },
  };
};
